export enum VirtualClassReportType {
    ActivityReport = 0,
    StatisticalParticipationReport = 1,
    SessionStatisticsReport = 2
}